import { defineMessages } from 'react-intl';

const GIVING_BACK_STRINGS = defineMessages({
  CAMPING_TO_CONNECT: {
    defaultMessage: 'Camping to Connect'
  },
  CAMPING_TO_CONNECT_DESC: {
    defaultMessage: 'This BIPOC-led organization shares the magic of the outdoors with underserved communities.'
  },
  CONSERVATION_ALLIANCE: {
    defaultMessage: 'The Conservation Alliance'
  },
  CONSERVATION_ALLIANCE_DESC: {
    defaultMessage: 'Our contribution supports private/public partnerships that protect wild places we love.'
  },
  FIRST_DESCENTS: {
    defaultMessage: 'First Descents'
  },
  FIRST_DESCENTS_DESC: {
    defaultMessage: 'Creating adventure for young people with big diagnoses, this organization heals with nature.'
  },
  LEAVE_NO_TRACE: {
    defaultMessage: 'Leave No Trace'
  },
  LEAVE_NO_TRACE_DESC: {
    defaultMessage: 'We are advocates for LNT’s mission to keep outdoor spaces clean, safe, and kind.'
  },
  ONE_TREE_PLANTED: {
    defaultMessage: 'One Tree Planted'
  },
  ONE_TREE_PLANTED_DESC: {
    defaultMessage: 'On top of our 1% contribution, we plant trees for gear store orders, anniversaries, & more.'
  },
  SEMPERVIRENS: {
    defaultMessage: 'Sempervirens Fund'
  },
  SEMPERVIRENS_DESC: {
    defaultMessage: 'With our headquarters in San Francisco, protecting the Redwoods is close to our hearts.'
  }
});

export default GIVING_BACK_STRINGS;
